/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServiceTypeTemplateQuestionsService {
  /**
   * @summary List Questions
   * @description List all questions for a service type template.
   */
  listServiceTypeTemplateQuestions: {
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<ListServiceTypeTemplateQuestionsParameters, TMeta, TSignal>,
      client?: (
        schema: ListServiceTypeTemplateQuestionsSchema,
        options: {
          parameters: ListServiceTypeTemplateQuestionsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsError>>
    ): Promise<RequestFnResponse<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsError>>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    getQueryKey(
      parameters: DeepReadonly<ListServiceTypeTemplateQuestionsParameters>
    ): ServiceOperationQueryKey<ListServiceTypeTemplateQuestionsSchema, ListServiceTypeTemplateQuestionsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Questions
     * @description List all questions for a service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListServiceTypeTemplateQuestionsData>(
      parameters:
        | ServiceOperationQueryKey<ListServiceTypeTemplateQuestionsSchema, ListServiceTypeTemplateQuestionsParameters>
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          ListServiceTypeTemplateQuestionsData,
          ListServiceTypeTemplateQuestionsError,
          TData,
          ServiceOperationQueryKey<ListServiceTypeTemplateQuestionsSchema, ListServiceTypeTemplateQuestionsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListServiceTypeTemplateQuestionsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Questions
     * @description List all questions for a service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListServiceTypeTemplateQuestionsData>(
      parameters:
        | ServiceOperationQueryKey<ListServiceTypeTemplateQuestionsSchema, ListServiceTypeTemplateQuestionsParameters>
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          ListServiceTypeTemplateQuestionsData,
          ListServiceTypeTemplateQuestionsError,
          TData,
          ServiceOperationQueryKey<ListServiceTypeTemplateQuestionsSchema, ListServiceTypeTemplateQuestionsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListServiceTypeTemplateQuestionsError>>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListServiceTypeTemplateQuestionsParameters>
    ): ServiceOperationInfiniteQueryKey<
      ListServiceTypeTemplateQuestionsSchema,
      ListServiceTypeTemplateQuestionsParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Questions
     * @description List all questions for a service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListServiceTypeTemplateQuestionsParameters,
      TQueryFnData = ListServiceTypeTemplateQuestionsData,
      TData = OperationInfiniteData<TQueryFnData, ListServiceTypeTemplateQuestionsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsParameters
          >
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListServiceTypeTemplateQuestionsError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListServiceTypeTemplateQuestionsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Questions
     * @description List all questions for a service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListServiceTypeTemplateQuestionsParameters,
      TQueryFnData = ListServiceTypeTemplateQuestionsData,
      TData = OperationInfiniteData<TQueryFnData, ListServiceTypeTemplateQuestionsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsParameters
          >
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListServiceTypeTemplateQuestionsError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListServiceTypeTemplateQuestionsData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListServiceTypeTemplateQuestionsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Questions
     * @description List all questions for a service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listServiceTypeTemplateQuestionsTotal = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listServiceTypeTemplateQuestionsByParametersTotal = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
        | QueryFiltersByQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Questions
     * @description List all questions for a service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listServiceTypeTemplateQuestionsResults = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * listServiceTypeTemplateQuestionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listServiceTypeTemplateQuestionsCombinedResults = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * listServiceTypeTemplateQuestionsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListServiceTypeTemplateQuestionsSchema,
          ListServiceTypeTemplateQuestionsParameters,
          ListServiceTypeTemplateQuestionsData,
          ListServiceTypeTemplateQuestionsError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Questions
     * @description List all questions for a service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useSuspenseQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListServiceTypeTemplateQuestionsData>(
      parameters:
        | ServiceOperationQueryKey<ListServiceTypeTemplateQuestionsSchema, ListServiceTypeTemplateQuestionsParameters>
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          ListServiceTypeTemplateQuestionsData,
          ListServiceTypeTemplateQuestionsError,
          TData,
          ServiceOperationQueryKey<ListServiceTypeTemplateQuestionsSchema, ListServiceTypeTemplateQuestionsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListServiceTypeTemplateQuestionsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Questions
     * @description List all questions for a service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useSuspenseInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListServiceTypeTemplateQuestionsParameters,
      TData = ListServiceTypeTemplateQuestionsData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsParameters
          >
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListServiceTypeTemplateQuestionsData,
          ListServiceTypeTemplateQuestionsError,
          OperationInfiniteData<TData, ListServiceTypeTemplateQuestionsParameters>,
          ServiceOperationInfiniteQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListServiceTypeTemplateQuestionsData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListServiceTypeTemplateQuestionsParameters>,
      OperationError<ListServiceTypeTemplateQuestionsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Questions
     * @description List all questions for a service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listServiceTypeTemplateQuestionsData = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * listServiceTypeTemplateQuestionsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listServiceTypeTemplateQuestionsCombinedData = qraft.serviceTypeTemplateQuestionsService.listServiceTypeTemplateQuestions.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * listServiceTypeTemplateQuestionsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListServiceTypeTemplateQuestionsSchema,
          ListServiceTypeTemplateQuestionsParameters,
          ListServiceTypeTemplateQuestionsData,
          ListServiceTypeTemplateQuestionsError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListServiceTypeTemplateQuestionsSchema,
        ListServiceTypeTemplateQuestionsData,
        ListServiceTypeTemplateQuestionsParameters,
        ListServiceTypeTemplateQuestionsError
      >
    ): Promise<ListServiceTypeTemplateQuestionsData>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListServiceTypeTemplateQuestionsSchema,
        ListServiceTypeTemplateQuestionsData,
        ListServiceTypeTemplateQuestionsParameters,
        ListServiceTypeTemplateQuestionsError
      >
    ): Promise<void>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListServiceTypeTemplateQuestionsSchema,
        ListServiceTypeTemplateQuestionsData,
        ListServiceTypeTemplateQuestionsParameters,
        ListServiceTypeTemplateQuestionsError
      >
    ): Promise<ListServiceTypeTemplateQuestionsData>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    fetchInfiniteQuery<TPageParam extends ListServiceTypeTemplateQuestionsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListServiceTypeTemplateQuestionsSchema,
        ListServiceTypeTemplateQuestionsData,
        ListServiceTypeTemplateQuestionsParameters,
        DeepReadonly<TPageParam>,
        ListServiceTypeTemplateQuestionsError
      >
    ): Promise<OperationInfiniteData<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsParameters>>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    prefetchInfiniteQuery<TPageParam extends ListServiceTypeTemplateQuestionsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListServiceTypeTemplateQuestionsSchema,
        ListServiceTypeTemplateQuestionsData,
        ListServiceTypeTemplateQuestionsParameters,
        DeepReadonly<TPageParam>,
        ListServiceTypeTemplateQuestionsError
      >
    ): Promise<void>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    ensureInfiniteQueryData<TPageParam extends ListServiceTypeTemplateQuestionsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListServiceTypeTemplateQuestionsSchema,
        ListServiceTypeTemplateQuestionsData,
        ListServiceTypeTemplateQuestionsParameters,
        DeepReadonly<TPageParam>,
        ListServiceTypeTemplateQuestionsError
      >
    ): Promise<OperationInfiniteData<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsParameters>>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListServiceTypeTemplateQuestionsSchema, ListServiceTypeTemplateQuestionsParameters>
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>
    ): ListServiceTypeTemplateQuestionsData | undefined;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsParameters
          >
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>
    ):
      | OperationInfiniteData<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsParameters>
      | undefined;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
        | QueryFiltersByQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListServiceTypeTemplateQuestionsSchema,
              ListServiceTypeTemplateQuestionsParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ListServiceTypeTemplateQuestionsData,
                    ListServiceTypeTemplateQuestionsParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListServiceTypeTemplateQuestionsSchema,
              ListServiceTypeTemplateQuestionsParameters
            >,
            data: ListServiceTypeTemplateQuestionsData | undefined,
          ]
        >;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListServiceTypeTemplateQuestionsSchema, ListServiceTypeTemplateQuestionsParameters>
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>
    ): QueryState<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsError> | undefined;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>
        | ServiceOperationInfiniteQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsParameters>,
          ListServiceTypeTemplateQuestionsError
        >
      | undefined;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    setQueryData(
      parameters:
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>
        | ServiceOperationQueryKey<ListServiceTypeTemplateQuestionsSchema, ListServiceTypeTemplateQuestionsParameters>,
      updater: Updater<
        NoInfer<ListServiceTypeTemplateQuestionsData> | undefined,
        NoInfer<DeepReadonly<ListServiceTypeTemplateQuestionsData>> | undefined
      >,
      options?: SetDataOptions
    ): ListServiceTypeTemplateQuestionsData | undefined;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<ListServiceTypeTemplateQuestionsParameters>
        | ServiceOperationInfiniteQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsParameters>
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<ListServiceTypeTemplateQuestionsData, ListServiceTypeTemplateQuestionsParameters>
      | undefined;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
        | QueryFiltersByQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >,
      updater: Updater<
        NoInfer<ListServiceTypeTemplateQuestionsData> | undefined,
        NoInfer<ListServiceTypeTemplateQuestionsData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListServiceTypeTemplateQuestionsData | undefined>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListServiceTypeTemplateQuestionsSchema,
        ListServiceTypeTemplateQuestionsData,
        TInfinite,
        ListServiceTypeTemplateQuestionsParameters,
        ListServiceTypeTemplateQuestionsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
        | QueryFiltersByQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
        | QueryFiltersByQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
        | QueryFiltersByQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
    ): void;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
        | QueryFiltersByQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary List Questions
     * @description List all questions for a service type template.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
        | QueryFiltersByQueryKey<
            ListServiceTypeTemplateQuestionsSchema,
            ListServiceTypeTemplateQuestionsData,
            TInfinite,
            ListServiceTypeTemplateQuestionsParameters,
            ListServiceTypeTemplateQuestionsError
          >
    ): number;
    schema: ListServiceTypeTemplateQuestionsSchema;
    types: {
      parameters: ListServiceTypeTemplateQuestionsParameters;
      data: ListServiceTypeTemplateQuestionsData;
      error: ListServiceTypeTemplateQuestionsError;
    };
  };
}
/**
 * @summary List Questions
 * @description List all questions for a service type template.
 */
export const listServiceTypeTemplateQuestions = {
  schema: {
    method: 'get',
    url: '/service_type_templates/{template_id}/questions',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListServiceTypeTemplateQuestionsSchema;
  [QraftServiceOperationsToken]: ServiceTypeTemplateQuestionsService['listServiceTypeTemplateQuestions'];
};
export const serviceTypeTemplateQuestionsService = {
  listServiceTypeTemplateQuestions,
} as const;
type ListServiceTypeTemplateQuestionsSchema = {
  method: 'get';
  url: '/service_type_templates/{template_id}/questions';
  security: ['HTTPBearer'];
};
type ListServiceTypeTemplateQuestionsParameters =
  paths['/service_type_templates/{template_id}/questions']['get']['parameters'];
type ListServiceTypeTemplateQuestionsData =
  paths['/service_type_templates/{template_id}/questions']['get']['responses']['200']['content']['application/json'];
type ListServiceTypeTemplateQuestionsError =
  paths['/service_type_templates/{template_id}/questions']['get']['responses']['422']['content']['application/json'];
